import styled from "styled-components";

export const Container = styled.div`
    
`;
export const StepRow = styled.div`
    padding-bottom: 20px;
    position: relative;
    :last-child{
        padding-bottom: 0;
    }
    ::before{
        height: calc(100% - 24px);
        width: 1px;
        border-left: 1px #D5E3EF dashed;
        content: "";
        position: absolute;
        left: 12px;
        top: 24px;
    }
    h4{
        display: flex;
        align-items: center;
        cursor: pointer;
        .count{
            width: 24px;
            height: 24px;
            background: #F2F8FF;
            border: 1px dashed #D5E3EF;
            border-radius: 50%;
            flex-shrink: 0;
            margin-right: 16px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 10px;
            color: #A0B0BC;
            font-weight: 900;
        }
        .title{
            font-size: 14px;
            font-weight: 900;
        }
    }
    ${p => p.selected && `
        h4{
            .count{
                background: #E6F7FD;
                border: 1px dashed #9BBFF3;
                color: #31478C;
            }
        }
    `}
`;
export const StepDesc = styled.p`
    font-size: 11px;
    line-height: 16px;
    color: #000000;
    padding-left: 40px;
    padding-top: 3px;
`;